const initState = {
    country: [],
    pickupDetails: {},
    contactDetails: {},
    selectedReason: null,
    returnNotes: '',
    orderableStatus: [],
};

const SET_RETURNCHECKOUT_COUNTRY = 'SET_RETURNCHECKOUT_COUNTRY';
const SET_RETURNCHECKOUT_PICKDETAILS_FORM = 'SET_RETURNCHECKOUT_PICKDETAILS_FORM';
const SET_RETURNCHECKOUT_CONTACTDETAILS = 'SET_RETURNCHECKOUT_CONTACTDETAILS';
const SET_SELECTED_REASON = 'SET_SELECTED_REASON';
const SET_RETURN_NOTES = 'SET_RETURN_NOTES';
const RESET_STATE = 'RESET_STATE';
const SET_ORDERABLE_STATUS = 'SET_ORDERABLE_STATUS';

export const setCountryList = (data) => ({ type: SET_RETURNCHECKOUT_COUNTRY, payload: data });
export const savePickupDetailsFormValue = (data) => ({
    type: SET_RETURNCHECKOUT_PICKDETAILS_FORM,
    payload: data,
});
export const saveContactDetailsFormValue = (data) => ({
    type: SET_RETURNCHECKOUT_CONTACTDETAILS,
    payload: data,
});
export const setSelectedReason = (data) => ({ type: SET_SELECTED_REASON, payload: data });
export const setReturnNotes = (data) => ({ type: SET_RETURN_NOTES, payload: data });
export const resetReturnWizard = () => ({ type: RESET_STATE, payload: initState });
export const setOrderableStatus = (data) => ({ type: SET_ORDERABLE_STATUS, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_RETURNCHECKOUT_COUNTRY:
            return { ...state, country: action.payload };
        case SET_RETURNCHECKOUT_PICKDETAILS_FORM:
            return { ...state, pickupDetails: action.payload };
        case SET_RETURNCHECKOUT_CONTACTDETAILS:
            return { ...state, contactDetails: action.payload };
        case SET_SELECTED_REASON:
            return { ...state, selectedReason: action.payload };
        case SET_RETURN_NOTES:
            return { ...state, returnNotes: action.payload };
        case RESET_STATE:
            return { ...state, ...action.payload };
        case SET_ORDERABLE_STATUS:
            return { ...state, orderableStatus: action.payload };
        default:
            return state;
    }
};
